export default __webpack_public_path__ + "static/media/Level Slash.504e00ad.png";